import { Link } from 'react-router-dom';
import MemberShortSummary from './member-short-summary';
import { Col, Container, Row } from 'react-bootstrap';
import type { MemberSummary } from '../types/api.types';

interface MembersOverviewProps {
  lstMembers: MemberSummary[];
}

export default function MembersOverview({ lstMembers }: MembersOverviewProps) {
  const memberNames = lstMembers.map((member) => (
    <Col xl={4} key={member.id}>
      <MemberShortSummary key={member.id} member={member} />
    </Col>
  ));

  return (
    <div>
      <Container>
        <div style={{ textAlign: 'right' }}>
          <p>
            <span>{`${lstMembers.length} members - `}</span>
            <Link to="/members/handicaps">Handicaps</Link>
          </p>
        </div>
        <Row>{memberNames}</Row>
      </Container>
    </div>
  );
}
